
export const SHEMA_PROVIDER = {
    INTERNAL: 'INTERNAL',
    MERCADO_ENVIOS_FLEX: 'MERCADO_ENVIOS_FLEX'
}

export const INTERNAL_SHEMA = {
    TIENDA: {
        prop: 'storeName',
        type: String,
        required: true
    },
    'NOMBRE DEL DESTINATARIO': {
        prop: 'customerName',
        type: String
    },
    'TELÉFONO DEL DESTINATARIO': {
        prop: 'customerPhone',
        type: String,
        required: true
    },
    'DIRECCIÓN DE DESTINO': {
        prop: 'customerAddress',
        type: String,
        required: true
    },
    'COMUNA DE DESTINO': {
        prop: 'customerCommune',
        type: String,
        required: true
    },
    OBSERVACIONES: {
        prop: 'observations',
        type: String
    },
    CORREO: {
        prop: 'customerEmail',
        type: String
    },
    'TAMAÑO DEL PAQUETE': {
        prop: 'size',
        type: String
    },
    'CANTIDAD DE BULTOS': {
        prop: 'bundleQuantity',
        type: String
    },
    TAGS: {
        prop: 'tags',
        type: String
    },
    'N° DE PAQUETE': {
        prop: 'labelCode',
        type: String
    },
    'N° DE ENVÍO': {
        prop: 'labelCode2',
        type: String
    },
    'ID EXTERNO': {
        prop: 'externalId',
        type: String
    }
}

export const MERCADO_ENVIOS_FLEX_SHEMA = {
    // Pack u orden de Mercado Libre. Si "Número de seguimiento" trae un hash en
    // vez del nº de envío, el backend lo resuelve con este id vía la API de ML.
    '# de venta': {
        prop: 'saleId',
        type: String
    },

    Comprador: {
        prop: 'customerName',
        type: String
    },

    Domicilio: {
        prop: 'customerAddress',
        type: String,
        required: true
    },

    Comuna: {
        prop: 'customerCommune',
        type: String,
        required: true
    },

    'Número de seguimiento': {
        prop: 'labelCode',
        type: String
    },

    'Forma de entrega': {
        prop: 'deliveryMethod',
        type: String
    },
}

export const FLEX_DELIVERY_METHOD = 'mercado envios flex'

const normalizeText = (text) => {
    if (!text) return ''
    return text.toString().trim().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

// solo se importan las ventas cuya "Forma de entrega" es Mercado Envíos Flex
export const isFlexDelivery = (shipment) =>
    normalizeText(shipment?.deliveryMethod) === FLEX_DELIVERY_METHOD

export const tags = {
    FLEX: 'flex',
    CAMBIO: 'exchange',
    DEVOLUCIÓN: 'return'
}
